<!-- reward detail start -->
<div class="smooth-scrolling without-sub-header set-top">
    <section class="reward-detail p-80">
        <div class="mx-1485">
            <div class="row">
                <div class="col-lg-5">
                    <div class="main-title">
                        <h3>Rewards</h3>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="reward-description">
                        <span>Get rewarded for your loyalty to us. Join our FOY rewards program and get your exclusive
                            access to discounts, free product samples, and a whole lot of other perks you can’t say no
                            to. Once you sign up for our loyalty program, you can earn points with every purchase.
                            Collect enough and redeem interesting and fun rewards. You can add to your point count by
                            referring us to a friend and reviewing your favourite products. It’s a total win-win!</span>
                        <span class="mt-50">
                            Introducing Our Skincare Loyalty Program: Earn Rewards for Your Commitment to Beauty
                            At FOY, we believe that loyalty should be rewarded. That’s why we’re excited to announce
                            the launch of our Skincare Loyalty Program, designed to give back to our most devoted
                            customers.</span>
                        <span>Here&#39;s how it works:</span>
                        <span>You’ll earn 250 bonus points just for signing up!</span>
                        <span>Earn Points with Every Purchase: For every rupee you spend on our site, you’ll earn one
                            point. As you accumulate points, you’ll unlock special rewards.</span>
                        <span>Redeem Your Points for Discounts: Once you’ve earned points, you can redeem them for
                            discounts on future purchases. Here’s how the rewards breakdown works:</span>
                        <span><b>1000 points = Rs 50</b></span>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="earn-point">
                        <span>Moreover -</span>
                        <ul>
                            <li>Earn 100 points for following us on social</li>
                            <li>Earn 250 points for posting a review with a photo</li>
                            <li>Refer Friends for Even More Points: Want to earn even more points? Refer your friends to
                                our website and earn 250 bonus points for each new customer you bring in.</li>
                        </ul>
                        <span><b>Sign up today and start earning points!</b></span>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- reward detail end -->
</div>
<!-- Footer START -->
<app-footer></app-footer>
<!-- Footer END -->